import { useQuery, useQueryClient } from '@tanstack/react-query';
import { authService } from '@/services/api';

export const sessionKey = ['session'] as const;

export function useSession() {
  return useQuery({
    queryKey: sessionKey,
    queryFn: authService.session,
    staleTime: 5 * 60_000,
    retry: false,
  });
}

export function useSignOut() {
  const qc = useQueryClient();
  return async () => {
    await authService.logout().catch(() => undefined);
    qc.clear();
    qc.setQueryData(sessionKey, null);
  };
}
